import styled from 'styled-components';

type Variant = 'open' | 'scheduled-to-close' | 'closed' | 'scheduled-to-open';

const getBackgroundColor = (variant: Variant) => {
  switch (variant) {
    case 'open':
      return 'rgb(209, 250, 229)'; // Verde claro pastel
    case 'scheduled-to-close':
      return 'rgb(219, 234, 254)'; // Azul claro pastel
    case 'closed':
      return 'rgb(243, 244, 246)'; // Gris claro
    case 'scheduled-to-open':
      return 'rgb(254, 243, 199)'; // Amarillo claro pastel
    default:
      return '#F5F5F5';
  }
};

const getTextColor = (variant: Variant) => {
  switch (variant) {
    case 'open':
      return 'rgb(21, 128, 61)'; // Verde oscuro
    case 'scheduled-to-close':
      return 'rgb(29, 78, 216)'; // Azul medio
    case 'closed':
      return 'rgb(55, 65, 81)'; // Gris oscuro
    case 'scheduled-to-open':
      return 'rgb(180, 83, 9)'; // Naranja/marrón
    default:
      return '#424242';
  }
};

export const StatusContainer = styled.div<{ variant: Variant }>`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => getBackgroundColor(props.variant)};
  border-radius: 9999px;
  padding: 6px 8px 6px 12px;
  gap: 16px;
  width: fit-content;
`;

export const StatusBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1;
`;

export const StatusIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  
  svg {
    display: block;
    width: 16px;
    height: 16px;
  }
`;

export const StatusContent = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const StatusMainText = styled.span<{ variant: Variant }>`
  font-size: 14px;
  font-weight: 600;
  line-height: 17px;
  color: ${props => getTextColor(props.variant)};
`;

export const StatusSubText = styled.span<{ variant: Variant }>`
  font-size: 12px;
  font-weight: 400;
  line-height: 15px;
  color: ${props => getTextColor(props.variant)};
`;

export const ChangeButton = styled.button<{ variant: Variant }>`
  display: flex;
  align-items: center;
  gap: 4px;
  background: white;
  color: rgb(3, 7, 18);
  border: none;
  border-radius: 9999px;
  padding: 3px 12px;
  font-size: 12px;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.15s ease;
  flex-shrink: 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  white-space: nowrap;

  &:hover {
    background: #f8f8f8;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: scale(0.97);
  }
`;

export const ArrowIcon = styled.span`
  font-size: 18px;
  line-height: 1;
  font-weight: 300;
  margin-left: 1px;
  svg {
    height: 13px;
    width: 9px;
  }
`;

